import {
    CARD_VOUCHER_COMPARISON,
    INITIAL_DATA_FILTER,
    SORT_VOUCHER,
    TABLE_VOUCHER,
} from 'configs/analytics/configTableVoucher'
import DateRangePicker from 'components/commons/date-range-picker'
import moment from 'moment/moment'
import { Button } from 'avo-ui'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import TabToggle from 'components/commons/tab-toogle'
import Graph from 'components/commons/graph'
import PageLimit from 'components/commons/page-limit'
import Sort from 'components/commons/sort'
import Table from 'components/commons/table'
import Search from 'components/commons/search'
import ModalExport from 'components/commons/modal-export'
import CardComparison from 'components/commons/card-comparison'
import { useRef } from 'react'

export const Voucher = ({
    dataComparison,
    dataGraph,
    dataList,
    query,
    onChangeQuery,
    onSelectSort,
    showModalExport,
    setShowModalExportHandler,
    isLoadingComparison,
    isLoadingGraph,
    isLoadingList,
    isLoadingExport,
    onExport,
}) => {
    const listRef = useRef()
    const initDate = [INITIAL_DATA_FILTER?.startDate, INITIAL_DATA_FILTER?.endDate]

    const onChangePage = (value) => {
        listRef.current?.scrollIntoView()
        onChangeQuery(value)
    }

    return (
        <div className={'flex flex-col gap-y-5 px-9 py-5'}>
            <div className={'flex space-x-3'}>
                <DateRangePicker
                    value={query?.startDate ? [query?.startDate, query?.endDate] : initDate}
                    onChange={(value) =>
                        onChangeQuery({
                            ...INITIAL_DATA_FILTER,
                            startDate: value[0] || initDate[0],
                            endDate: value[1] || initDate[1],
                        })
                    }
                    maxDate={moment()}
                    format={'YYYY-MM-DD'}
                />
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    disabled={!dataList?.total_result}
                    onClick={() => setShowModalExportHandler(true)}
                />
            </div>
            <TabToggle
                title={'Voucher & Comparison'}
                isLoading={isLoadingComparison}
                content={
                    <div className={'grid grid-cols-2 gap-4'}>
                        {CARD_VOUCHER_COMPARISON?.map((item) => (
                            <CardComparison
                                key={item?.name}
                                title={item?.title}
                                name={item?.name}
                                isCurrency={item?.isCurrency}
                                dataComparison={dataComparison}
                            />
                        ))}
                    </div>
                }
            />
            <TabToggle
                title={'Voucher Orders Graph'}
                isLoading={isLoadingGraph}
                content={<Graph title={'Total Order'} name={'order'} values={dataGraph || {}} />}
            />
            <TabToggle
                title={'Voucher Orders'}
                content={
                    <div ref={listRef} className={'overflow-auto'}>
                        <div className={'flex space-x-3'}>
                            <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                            <PageLimit
                                value={query?.limit}
                                onSelect={(value) => onChangeQuery({ limit: value, page: 1 })}
                            />
                            <Sort
                                options={SORT_VOUCHER}
                                value={`${query?.orderBy}_${query?.orderType}`}
                                onSelect={(value) => onSelectSort(value)}
                            />
                        </div>
                        <div>
                            <Table
                                className={'my-3'}
                                name={TABLE_VOUCHER.name}
                                columns={TABLE_VOUCHER.column}
                                data={dataList?.results}
                                size={query?.limit}
                                currentPage={query?.page}
                                totalPage={dataList?.total_page}
                                totalResult={dataList?.total_result}
                                onChangePage={(val) => onChangePage({ page: val })}
                                loading={isLoadingList}
                            />
                        </div>
                    </div>
                }
            />
            {showModalExport && (
                <ModalExport
                    show={showModalExport}
                    onHide={() => setShowModalExportHandler(false)}
                    description={'Are You Sure Export This?'}
                    totalData={dataList?.total_result}
                    isLoading={isLoadingExport}
                    onExport={onExport}
                />
            )}
        </div>
    )
}
